import { TamediaStyles } from '@ta-interaktiv/microfrontend-template-helpers'
import { FC, ReactElement } from 'react'
import styled, { css } from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'

import {
  ReadDataFromDbAndAddItToWindow,
  ReadDataFromWindow
} from 'components/WindowCommunication'
import { Part1 } from 'components/_Part1'
import { Part2 } from 'components/_Part2'
import { Part3 } from 'components/_Part3'
import { Part4 } from 'components/_Part4'
import { Part5 } from 'components/_Part5'
import { Part6 } from 'components/_Part6'
import { Part7 } from 'components/_Part7'
import { Part0 } from 'components/_Part0'
import {
  HeaderImage,
  HeaderInjection
} from '@ta-interaktiv/react-header-injection'
import { MFContextProvider } from 'components/MFHelpers'

export const swissStatsData = {
  average: 2.9
}

// export const nfp = new Intl.NumberFormat('de-CH')

// DYNAMIC TEXTS
const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : ''
  ]

  const partToShow = properties?.part ? properties.part : 'part2'
  const isDev = window.document.title === 'TA-Interaktiv Microfrontend'

  return (
    <AppContainer className={globalClasses.join(' ')} $colorMode={colorMode}>
      <ReadDataFromDbAndAddItToWindow />
      <ReadDataFromWindow />
      {partToShow === 'header' || isDev ? (
        <MFContextProvider
          locale={tenant?.lang || 'de'}
          colorMode={colorMode || 'light'}
          translations={{
            de: {},
            fr: {}
          }}
          properties={{}}
          tenantKey={tenant?.key || ''}
          trackEvent={() => {}}
        >
          <HeaderInjection
            content={
              <HeaderImage
                desktop={require('../../assets/header.jpg')}
                mobile={require('../../assets/header_mob.jpg')}
                darkDesktop={require('../../assets/header_dm.jpg')}
                darkMobile={require('../../assets/header_mob_dm.jpg')}
                colorMode={colorMode || 'light'}
                alt=''
                imageStyles={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            }
          />
        </MFContextProvider>
      ) : (
        <></>
      )}
      {/* {partToShow === 'part0' || isDev ? (
        <Part0 tenant={tenant} colorMode={colorMode} />
      ) : (
        <></>
      )} */}
      <TextWidth>
        {partToShow === 'part1' || isDev ? (
          <Part1 tenant={tenant} colorMode={colorMode} />
        ) : (
          <></>
        )}
        {partToShow === 'part2' || isDev ? (
          <Part2 tenant={tenant} colorMode={colorMode} />
        ) : (
          <></>
        )}
        {partToShow === 'part3' || isDev ? (
          <Part3 tenant={tenant} colorMode={colorMode} />
        ) : (
          <></>
        )}
        {partToShow === 'part4' || isDev ? (
          <Part4 tenant={tenant} colorMode={colorMode} />
        ) : (
          <></>
        )}
        {partToShow === 'part5' || isDev ? (
          <Part5 tenant={tenant} colorMode={colorMode} />
        ) : (
          <></>
        )}
        {partToShow === 'part6' || isDev ? (
          <Part6 tenant={tenant} colorMode={colorMode} />
        ) : (
          <></>
        )}
        {partToShow === 'part7' || isDev ? (
          <Part7 tenant={tenant} colorMode={colorMode} />
        ) : (
          <></>
        )}
      </TextWidth>
    </AppContainer>
  )
}

const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 2rem;
  line-height: 3rem;
  color: var(--text-color);
  /* background-color: var(--site-background); */
  /* overflow: hidden; */
  --text-color: #000000;
  --chapter-bg: var(--orange-bright-1);
  --chapter-text: black;
  --gray-bar-bg: var(--gray-6);
  p {
    font-size: 20px;
    line-height: 30px;
    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 26px;
    }
  }
  ${({ $colorMode: colorMode }) =>
    colorMode === 'dark'
      ? css`
          --text-color: #ffffff;
          --chapter-bg: var(--orange-bright-1);
          --chapter-text: white;
          --gray-bar-bg: var(--gray-2);
        `
      : ''}
  .ceta {
    color: green;
  }
`
export default MainComponent
